import React from 'react';
// utils
import T from 'prop-types';
import { getVideoId } from '../../utils/video.utils';
// redux
import { connect } from 'react-redux';
import { openVideo } from '../../redux/reducers/videoPlayer';
import { openModal } from '../../redux/reducers/modal';
// components
import Icon from '../Icon/Icon';
import ShrinkedText from '../ShrinkedText/ShrinkedText';
// styles
import classnames from 'classnames/bind';
import styles from './ResourcePreview.mod.css';

const cn = classnames.bind(styles);

const getBackgroundImage = resource => {
  const { content = {}, content_type } = resource;
  const link = content.link || resource.link;
  const type = content_type || 'video';
  const { preview_image } = content;
  if (type === 'video') {
    return `url(http://img.youtube.com/vi/${getVideoId(link)}/hqdefault.jpg)`;
  }
  if (preview_image && preview_image.url) {
    return `url(${preview_image.url})`;
  }
};

const prepareResourceData = resource => {
  const { content = {}, content_type } = resource;
  const { description, sound_link } = content;
  const type = content_type || 'video';
  const backgroundImage = getBackgroundImage(resource);
  return {
    type,
    description,
    backgroundImage,
    sound_link,
    link: content.link || resource.link,
    title: content.title || resource.title,
    content: content.content
  };
};

export const ResourcePreview = ({
  className = '',
  resource = {},
  openVideo,
  openModal
}) => {
  const {
    link,
    title,
    description,
    type,
    sound_link,
    backgroundImage,
    content
  } = prepareResourceData(resource);

  const onClick = () => {
    type === 'video' && openVideo(link, title);
    type === 'lecture' && openModal('LECTURE', { title, sound_link, content });
    type === 'link' && window.open(link, 'document');
  };

  const iconType = type === 'lecture' ? 'file' : type;

  return (
    <div className={cn(type, 'container', className)}>
      <div onClick={onClick} className={cn(type, 'wrapper')}>
        <div className={cn('resource')} style={{ backgroundImage }}>
          <span className={cn(`${type}-img`)} />
        </div>
        <span className={cn('icon-wrapper')}>
          <Icon type={iconType} className={cn('icon')} />
        </span>
        <ShrinkedText className={cn('title')} length={65}>
          {title}
        </ShrinkedText>
        <ShrinkedText className={cn('description')} length={65}>
          {description}
        </ShrinkedText>
      </div>
    </div>
  );
};

ResourcePreview.propTypes = {
  resource: T.shape({
    title: T.string,
    description: T.string,
    link: T.string
  }),
  playVideo: T.func,
  className: T.string
};

export default connect(
  null,
  { openVideo, openModal }
)(ResourcePreview);



// WEBPACK FOOTER //
// ./src/components/ResourcePreview/ResourcePreview.jsx